module.exports = "/assets/86eb49ea4723111c94e56f5a9097e3d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/BG.png
// module id = 1229
// module chunks = 0